module.exports = __webpack_public_path__ + "static/media/Connect.bd311db6.png";